import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const statusColors = {
  pending:     { bg: '#fff8e6', color: '#f59e0b' },
  reviewed:    { bg: '#e8f0ff', color: '#0066FF' },
  shortlisted: { bg: '#e6fff6', color: '#00C896' },
  rejected:    { bg: '#fff0f0', color: '#ef4444' },
  hired:       { bg: '#e6fff6', color: '#00C896' },
};

export default function MyApplications() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading]           = useState(true);
  const [error, setError]               = useState('');

  useEffect(() => {
    fetch('http://localhost:5000/api/applications/my', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(r => r.json())
      .then(data => { setApplications(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => { setError('Failed to load applications'); setLoading(false); });
  }, []);

  const handleWithdraw = async (id) => {
    if (!window.confirm('Withdraw this application?')) return;
    await fetch(`http://localhost:5000/api/applications/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    setApplications(applications.filter(a => a._id !== id));
  };

  return (
    <>
      <PageHeader title="My Applications" breadcrumb="My Applications" />
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Dashboard</span>
            <h2 className="section-title">My Job Applications</h2>
            <p className="section-sub">Track the status of all your job applications</p>
          </div>

          {loading && <div className="text-center py-5"><i className="fa fa-spinner fa-spin fa-2x text-primary"></i></div>}
          {error   && <div className="auth-alert error"><i className="fa fa-exclamation-circle me-2"></i>{error}</div>}

          {!loading && applications.length === 0 && (
            <div className="jl-empty">
              <i className="fa fa-file-alt"></i>
              <h5>No applications yet</h5>
              <p>Start applying to jobs to see them here</p>
              <Link to="/job-list" className="btn-grad mt-3">Browse Jobs</Link>
            </div>
          )}

          {!loading && applications.length > 0 && (
            <div className="jobs-list">
              {applications.map((app, i) => {
                const s = statusColors[app.status] || statusColors.pending;
                return (
                  <div className="job-card-pro" key={i}>
                    <div className="job-card-left">
                      <div className="job-logo-wrap">
                        {app.job?.logo
                          ? <img src={app.job.logo} alt="" />
                          : <div style={{ width: '100%', height: '100%', background: '#e8f0ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0066FF', fontSize: 22 }}><i className="fa fa-building"></i></div>
                        }
                      </div>
                      <div className="job-info">
                        <div className="job-top-row">
                          <h5>{app.job?.title || 'Job Title'}</h5>
                          <span className="jl-tag" style={{ background: s.bg, color: s.color }}>
                            {app.status?.charAt(0).toUpperCase() + app.status?.slice(1)}
                          </span>
                        </div>
                        <p style={{ fontSize: 13, color: '#888', margin: '0 0 8px' }}>{app.job?.company}</p>
                        <div className="job-meta">
                          <span><i className="fa fa-map-marker-alt"></i>{app.job?.location}</span>
                          <span><i className="far fa-clock"></i>{app.job?.type}</span>
                          <span><i className="far fa-money-bill-alt"></i>{app.job?.salary}</span>
                          <span><i className="far fa-calendar-alt"></i>Applied {new Date(app.createdAt).toLocaleDateString()}</span>
                        </div>
                      </div>
                    </div>
                    <div className="job-card-right">
                      <Link to="/job-detail" className="jl-apply-btn">View Job</Link>
                      {app.status === 'pending' && (
                        <button className="jl-save-btn" onClick={() => handleWithdraw(app._id)} title="Withdraw">
                          <i className="fa fa-times"></i>
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
